module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-1-red.svg";